import { mapGetters } from 'vuex';
export const DEFAULT_CONVERSATION_SIDEBAR_ITEMS_ORDER = [
  { name: 'conversation_actions' },
  { name: 'conversation_info' },
  { name: 'contact_attributes' },
  { name: 'previous_conversation' },
  { name: 'conversation_files' },
  { name: 'conversation_summary' },
];
export const DEFAULT_CONTACT_SIDEBAR_ITEMS_ORDER = [
  { name: 'contact_attributes' },
  { name: 'contact_labels' },
  { name: 'previous_conversation' },
];
export default {
  computed: {
    ...mapGetters({
      uiSettings: 'getUISettings',
    }),
    conversationSidebarItemsOrder() {
      const { conversation_sidebar_items_order: itemsOrder } = this.uiSettings;
      // return itemsOrder || DEFAULT_CONVERSATION_SIDEBAR_ITEMS_ORDER;
      return this.mergeSidebarItems(DEFAULT_CONVERSATION_SIDEBAR_ITEMS_ORDER, itemsOrder);
    },
    contactSidebarItemsOrder() {
      const { contact_sidebar_items_order: itemsOrder } = this.uiSettings;
      // return itemsOrder || DEFAULT_CONTACT_SIDEBAR_ITEMS_ORDER;
      return this.mergeSidebarItems(DEFAULT_CONTACT_SIDEBAR_ITEMS_ORDER, itemsOrder);
    },
  },
  methods: {
    updateUISettings(uiSettings = {}) {
      this.$store.dispatch('updateUISettings', {
        uiSettings: {
          ...this.uiSettings,
          ...uiSettings,
        },
      });
    },
    isContactSidebarItemOpen(key) {
      const { [key]: isOpen } = this.uiSettings;
      return !!isOpen;
    },
    toggleSidebarUIState(key) {
      this.updateUISettings({ [key]: !this.isContactSidebarItemOpen(key) });
    },
    mergeSidebarItems(defaultItems, userItems) {
      const safeUserItems = Array.isArray(userItems) ? userItems : [];
      const userItemNames = safeUserItems.map(item => item.name);

      // Keep user order first
      const merged = [...safeUserItems];

      // Add any new default items that user does not have yet
      defaultItems.forEach(item => {
        if (!userItemNames.includes(item.name)) {
          merged.push(item);
        }
      });

      return merged;
    },
  },
};
